/* eslint-env jquery, browser */
/* global Auth0Lock */
import container from 'modules/section-content';
import requireg from 'modules/npm-component/require-global';
import domify from 'domify';
import Batch from 'batch';
import page from 'modules/ab-page-js';
import React from 'react';
import { render } from 'react-dom';
import { LockPlayground } from 'components';
import splash from './lock-page.pug';
import metadata from './metadata.json';

export default function register() {
  page('/lock', renderPage, loadscripts, snippets);
}

function renderPage(ctx, next) {
  const renderOptions = {
    metadata,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);

  next();
}

function loadscripts(ctx, next) {
  const batch = new Batch();

  batch.push(done => {
    requireg(
      '//cdn2.auth0.com/jquery-libs/scrollmagic/js/jquery.scrollmagic.min.js',
      'ScrollMagic',
      err => {
        if (err) return done();
        return requireg(
          '//cdn2.auth0.com/jquery-libs/scrollmagic/js/jquery.scrollmagic.debug.js',
          'ScrollMagic',
          done
        );
      }
    );
  });

  batch.push(done => {
    requireg('https://cdn.auth0.com/website/assets/pages/lock/vendor/tooltips-a344d1455d.min.js', '$.fn.tooltip', done);
  });

  batch.end(next);
}

function snippets(ctx, next) {
  const lockX = new Auth0Lock('yKJO1ckwuY1X8gPEhTRfhJXyObfiLxih', 'mdocs.auth0.com', {
    allowedConnections: ['mdocs.io', 'google-oauth2'],
    container: 'iphone-container',
    rememberLastLogin: false,
    theme: {},
    language: 'en'
  });

  lockX.show();

  $(window).load(() => {
    setTimeout(() => {
      $('#iphone-container').addClass('animated fadeIn').css('visibility', 'visible');
    }, 1000);

    setTimeout(() => {
      $('.iphone.iphone-left').addClass('animated fadeInRight').css('visibility', 'visible');
      $('.iphone.iphone-right').addClass('animated fadeInLeft').css('visibility', 'visible');
    }, 1000);
  });

  renderLockPlayground();

  connectionsTabs();

  $('[data-toggle="tooltip"]').tooltip();

  next();
}

function connectionsTabs() {
  $('.tabs-connections li').click(function() {
    $('.tabs-connections li').removeClass('active');
    $(this).addClass('active');
    $('.connection-category').addClass('hide');
    $(`#${$(this).data('target')}`).removeClass('hide');

    return false;
  });
}

/**
 * Render playground lock
 */
function renderLockPlayground() {
  const el = document.getElementById('playground-next');

  render(<LockPlayground />, el);
}



// WEBPACK FOOTER //
// ./src/pages/lock/lock.js